import styled from 'styled-components';

import { BsChevronRight } from 'react-icons/bs';
import { AiOutlineUser } from 'react-icons/ai';

interface Active {
  active?: boolean;
  pending?: boolean;
}

export const Button = styled.button`
  width: 100%;
  height: 56px;
  color: rgba(0, 0, 0, 0.7);
  background-color: white;
  border-radius: 4px;
  border: 1px solid #11111115;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 16px;

  &:hover {
    background-color: #f3f3f330;
  }

  &:active {
    background-color: #f3f3f350;
  }
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333333;
  font-weight: normal;
  text-align: left;
  margin-right: 10px;
`;

export const IconSpecialist = styled(AiOutlineUser)`
  width: 20px;
  height: 20px;
  fill: #2fa8d5;
  margin-right: 10px;
`;

export const IconChevron = styled(BsChevronRight)`
  width: 16px;
  height: 16px;
  fill: #111;
`;

export const Status = styled.span<Active>`
  padding: 8px;
  background-color: #4f6787;
  color: #fdfdfd;
  border-radius: 6px;
  font-size: 14px;
  margin-left: 12px;
  padding: 12px;
`;
